import { RootState } from "store";

export const getLatestPayableInvoice = (state: RootState) =>
  state.invoice.byId[state.invoice.latestPayableId];
